import { render, staticRenderFns } from "./WeServeAddonSelector.vue?vue&type=template&id=19e72e8a&scoped=true&"
import script from "./WeServeAddonSelector.vue?vue&type=script&lang=js&"
export * from "./WeServeAddonSelector.vue?vue&type=script&lang=js&"
import style0 from "./WeServeAddonSelector.vue?vue&type=style&index=0&id=19e72e8a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19e72e8a",
  null
  
)

export default component.exports